import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';

interface BlogPost {
	id: string;
	title: string;
	date: string;
	category: string;
	excerpt: string;
}

const CATEGORY_COLORS: Record<string, string> = {
	Ankündigung: '#6C5CE7',
	Einblicke: '#00B894',
	Entwicklung: '#74B9FF',
	Version: '#6C5CE7',
};

const getCategoryColor = (category: string) =>
	CATEGORY_COLORS[category] ?? '#6C5CE7';

const formatDate = (dateStr: string) =>
	new Date(dateStr).toLocaleDateString('de-DE', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});

export const BlogSection = () => {
	const [posts, setPosts] = useState<BlogPost[]>([]);

	useEffect(() => {
		fetch('/blog-posts/index.json')
			.then((r) => r.json())
			.then((data: BlogPost[]) => {
				const sorted = data.sort(
					(a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
				);
				setPosts(sorted.slice(0, 3));
			})
			.catch(() => {});
	}, []);

	if (posts.length === 0) return null;

	return (
		<section className='blog-section'>
			<div className='blog-section__header'>
				<h2 className='blog-section__title'>Neuigkeiten aus dem Blog</h2>
				<p className='blog-section__subtitle'>
					Updates, Einblicke und Entwicklungsgeschichten rund um Erledix
				</p>
			</div>

			<div className='blog-section__grid'>
				{posts.map((post) => (
					<Link
						key={post.id}
						to={`/blog/${post.id}`}
						className='blog-section__card'
					>
						<div className='blog-section__card-meta'>
							<span
								className='blog-section__category'
								style={{ backgroundColor: getCategoryColor(post.category) }}
							>
								{post.category}
							</span>
							<span className='blog-section__date'>{formatDate(post.date)}</span>
						</div>
						<h3 className='blog-section__card-title'>{post.title}</h3>
						<p className='blog-section__card-excerpt'>{post.excerpt}</p>
						<span className='blog-section__read-more'>Weiterlesen →</span>
					</Link>
				))}
			</div>

			<div className='blog-section__cta'>
				<Link to='/blog' className='blog-section__cta-link'>
					Alle Beiträge ansehen
				</Link>
			</div>
		</section>
	);
};

